export default __webpack_public_path__ + "static/media/Rewind-logo.ce95e81e.svg";